<template>
    <div class="product-recommend">
        <div class="product-features-top SourceHanSansCN-Bold">
            <div class="product-features-line"></div>
            <div class="product-features-title SourceHanSansCN-Bold">产品推荐</div>
        </div>
        <div class="product-recommend-content">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(item, i) in cardList" :key="i">
                    <div class="cpzx-content-list-item" @click="info(item.id)">
                        <div class="cpzx-content-list-item-img">
                            <img :src="PinjieImgUrl + item.banner.split(',')[0]" alt="">
                        </div>
                        <div class="cpzx-content-list-item-bottom">
                            <div class="cpzx-content-list-item-bottom-left SourceHanSansCN-Regular">
                                <!-- {{ item.title }} -->
                                <div class="top_xinghao">
                                    {{ item.title.split('，')[0] }}
                                </div>
                                <div class="botton_txt">
                                    {{ item.title.split('，')[1] }}
                                </div>

                            </div>
                            <div class="cpzx-content-list-item-bottom-right SourceHanSansCN-Regular"><i class="el-icon-top-right
"></i></div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>

            <div class="product-recommend-content-but">
                <el-button class="item_top_right_btn SourceHanSansCN-Regular" icon="el-icon-back" circle
                    @click="throttledHandleNextleftClick"></el-button>
                <el-button class="item_top_right_btn SourceHanSansCN-Regular" icon="el-icon-right" circle
                    @click="throttledHandleNextrightClick"></el-button>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'; // 引入 lodash
import { listBjlfmenu } from "@/api/system/bjlfmenu"//读取北京鲁飞菜单列表

import { listBjlfproduct } from "@/api/system/bjlfproduct"//产品系列详情

export default {
    name: 'ProductRecommendation',
    data() {
        return {
            imgArr: [
                // require('../../assets/img/home1/手机探测门-鲁飞.png'),
                // require('../../assets/img/home1/20220620165114392.png'),
                // require('../../assets/img/home1/44e56d220dac6bf.png'),
                // require('../../assets/img/home1/9fe99fa2258d9d2.png'),
                // require('../../assets/img/home1/098c371aa3c5c08.png'),
                // require('../../assets/img/home1/8a84ffd26c783.png'),
            ],
            swiperOption: {
                slidesPerView: 4,       // 每页显示4个
                slidesPerGroup: 1,      // 每次滑动4个（关键：避免部分显示）
                spaceBetween: 20,       // 幻灯片间距（用Swiper内置属性，避免CSS gap冲突）
                loop: false,            // 先关闭循环，排查是否是循环导致的复制干扰
                initialSlide: 0, // 默认展示页
                // notNextTick: false,
                // loop: true,
                // touchRatio: 1, // 触摸滑动的顺畅度
                // autoplay: false, // 是否自动播放
                speed: 500, // 播放速度
                // slidesPerView: 4, // 同时展示的页数
                // slidesPerGroup: 1,   // 每次滑动 4 个幻灯片（核心）
                // centeredSlides: true,
                // paginationClickable: true,
                // spaceBetween: 20, // 模块之间的间隔
                pauseOnMouseEnter: true, // 关键：鼠标悬停时暂停
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    type: 'progressbar', // <-- 关键配置
                },
                // 核心配置：启用左右导航按钮
                navigation: {
                    nextEl: '.swiper-button-next', // 右按钮选择器
                    prevEl: '.swiper-button-prev', // 左按钮选择器
                },
            },
            cardList: [],
        }
    },
    created() {
        this.throttledHandleNextleftClick = _.throttle(this.leftClick, 1000);
        this.throttledHandleNextrightClick = _.throttle(this.rightClick, 1000);
        this.listBjlfproductFn();
    },
    beforeDestroy() {
        // 重要：在组件销毁前，取消节流，防止内存泄漏

        this.throttledHandleNextleftClick.cancel();
        this.throttledHandleNextrightClick.cancel();

    },
    methods: {
        leftClick() {
            this.$refs.mySwiper.swiper.slidePrev();
        },
        rightClick() {
            this.$refs.mySwiper.swiper.slideNext();
        },
        // 产品系列详情
        listBjlfproductFn() {
            listBjlfproduct({
                pageNum: 1, pageSize: 10
            }).then(res => {
                // console.log('产品系列详情,产品推荐', res)
                this.cardList = res.rows;
            })
        },
        // //产品详情
        info(id) {
            // console.log('产品详情', id)
            this.$router.replace({
                path: `/info?id=${id}`,
                // query: {
                //     cid: this.$route.query.cid,
                //     id: id
                // }
            })
        },
    }



}
</script>

<style scoped lang="less">
// 产品推荐
.product-recommend {
    padding-left: 280px;
    padding-right: 260px;
    box-sizing: border-box;
    margin-bottom: 154px;

    .product-recommend-content {


        .cpzx-content-list-item:hover {
            transition: all 0.3s;
            background: #E9F3FF;

            .cpzx-content-list-item-bottom {
                transition: all 0.3s;
                background: #004CA6 !important;
                color: #fff;

                .top_xinghao {
                    transition: all 0.3s;
                    color: #fff !important;
                }
            }

            .cpzx-content-list-item-img {
                img {
                    transition: transform 0.3s ease;
                    transform: scale(1.2);
                }
            }
        }

        .swiper-slide {
            width: 326px !important;
        }

        .cpzx-content-list-item {
            transition: all 0.3s;
            width: 100%;
            height: 400px;
            // padding: 94px 55px 85px 55px;
            // box-sizing: border-box;
            background: #F1F4F9;
            position: relative;

            .cpzx-content-list-item-img {
                width: 225px;
                height: 225px;
                padding-top: 50px;
                // box-sizing: border-box;
                margin: 0 auto;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    margin: 0 auto;
                    /* 设置过渡效果：作用于 transform 属性，时长 0.5 秒，缓动函数为 ease */
                    transition: transform 0.3s ease;
                }
            }

            .cpzx-content-list-item-bottom {
                transition: all 0.3s;

                display: flex;
                width: 100%;
                justify-content: space-between;
                background: #fff;
                height: 100px;
                // line-height: 70px;
                padding-left: 20px;
                padding-right: 20px;
                box-sizing: border-box;
                position: absolute;
                bottom: 0;
                font-size: 20px;
                align-items: center;

                .cpzx-content-list-item-bottom-left {
                    width: 220px;
                    overflow: hidden;
                    white-space: nowrap;
                    /*不换行*/
                    text-overflow: ellipsis;
                    /*超出部分文字以...显示*/

                    .top_xinghao {
                        font-size: 16px !important;
                        color: #999999;
                        letter-spacing: 1px;
                    }

                    .botton_txt {
                        font-size: 20px !important;

                    }
                }
            }


        }

        .product-recommend-content-but {
            display: flex;
            justify-content: center;
            margin-top: 135px;
            gap: 103px;

            .item_top_right_btn {
                width: 61px !important;
                height: 61px !important;
                font-size: 24px;
            }
        }
    }

    ::v-deep .el-button {
        color: #606266;
    }

    ::v-deep .el-button:focus,
    .el-button:hover {
        color: #FFF !important;
        border-color: #0653B3 !important;
        background-color: #0653B3 !important;
        transition: all 0.3s;
    }

    .el-button:focus:not(:hover) {
        background-color: #FFF !important;
        color: #606266 !important;
        border: 1px solid #DCDFE6 !important;
    }

}

// 标题横线 文字
.product-features-top {
    display: flex;
    margin-top: 84px;
    margin-bottom: 47px;
    align-items: center;
    gap: 13px;

    .product-features-line {
        width: 6px;
        height: 36px;
        background: #004CA6;
    }
    .product-features-title {
        font-weight: bold;
        color: #222222;
        font-size: 48px;
    }
}
</style>>